var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{key:_vm.refreshItem,ref:"cascaderRegion",staticStyle:{"width":"100%"},attrs:{"props":_vm.cascaderProps,"placeholder":_vm.placeholder,"options":_vm.regionList1},on:{"change":_vm.regionChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }